/** @jsxImportSource @emotion/react */
import React, { useCallback } from "react";
import { GlobalStore } from "../../store/global/GlobalStore";
import { calculateFee, getGasCost, getTokenOut } from "../../utils/quoteUtils";
import { FlexBetweenContainer } from "../../containers/FlexBetweenContainer";
import { FlexContainer } from "../../containers/FlexContainer";
import { DetailsRightColumnText } from "./elements/DetailsRightColumnText";
import { DetailsLeftColumnText } from "./elements/DetailsLeftColumnText";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { Spacer } from "components/general/Spacer/Spacer";
import { getTokenTicker } from "../../utils/tokenUtils";
import { CHAINS } from "config/chains";

export const NetworkFeeRow: React.FC = () => {
  const tokenList = useTokenListByChain();
  const { theme, quote, network } = GlobalStore.useState(s => {
    return {
      theme: s.theme,
      quote: s.quote,
      network: s.network,
    };
  });
  const SelectedNetworkIcon = CHAINS[network.id].icon;
  const FeeToDisplay = useCallback(() => {
    if (quote == null) {
      return <>${getGasCost(quote).format(2)}</>;
    }
    const symbol = getTokenOut(quote);
    if (symbol == null) {
      return <>${getGasCost(quote).format(2)}</>;
    }
    return (
      <>
        {calculateFee(quote).toDisplay(symbol, tokenList)} {getTokenTicker(symbol, tokenList)} ($
        {getGasCost(quote).format(2)})
      </>
    );
  }, [quote, tokenList]);

  return (
    <>
      <FlexBetweenContainer data-testid="network-fee-row" widthExpand={true}>
        <FlexContainer style={{ color: theme.font.secondary.default }} gap={2}>
          <DetailsLeftColumnText>Network cost</DetailsLeftColumnText>
          <Spacer minWidth={2} />
          <SelectedNetworkIcon width={16} height={16} />
        </FlexContainer>
        <FlexContainer>
          <DetailsRightColumnText>
            <FeeToDisplay />
          </DetailsRightColumnText>
        </FlexContainer>
      </FlexBetweenContainer>
    </>
  );
};
